import ApiService from "@/services/api.service";
import JwtService from '@/services/jwt.service';

const defaults = {
    getBanks() {
        return new Promise((resolve, reject) => {
            ApiService.get('banks').then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    getBranches() {
        return new Promise((resolve, reject) => {
            ApiService.get('branches/of-user').then(({ data }) => {
                var branchActive = false;
                data.map((branch, key) => {
                    if (branch.id == JwtService.getBranchId()) {
                        branchActive = true;
                    }
                });

                if (!branchActive && data.length > 0) {
                    JwtService.setBranch(data[0].id);
                    window.location.reload();
                }
                
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    getNotifications() {
        return new Promise((resolve, reject) => {
            ApiService.get('notifications').then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    getProposalStatus() {
        return new Promise((resolve, reject) => {
            ApiService.get('proposal_status').then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    getStates() {
        return new Promise((resolve, reject) => {
            ApiService.get('states').then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    readNotification(_id) {
        return new Promise((resolve, reject) => {
            ApiService.patch('notifications', _id, {}).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    searchCep(_cep) {
        return new Promise((resolve, reject) => {
            ApiService.get('addresses', _cep).then(({data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    }, 
    getCountInstallments(){
        return new Promise((resolve, reject) => {
            ApiService.get('installments/count').then(({data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    }
};

export default defaults;